import { App } from 'vue';
import navigation from './navigation';

export default function config(app: App): void {
    navigation(app);
}
